import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-form-subscription',
  templateUrl: './form-subscription.component.html',
  styleUrl: './form-subscription.component.scss'
})
export class FormSubscriptionComponent {

  @Input() plans: any[] = [];
  @Input() billingPeriod: 'monthly' | 'yearly' = 'monthly';
  @Input() selectedPlanId: number | null = null;
  @Input() showContinueButton: boolean = false;
  @Input() continueButtonLabel: string = 'Continuar';
  @Input() showPayButton: boolean = false;
  @Input() payButtonLabel: string = 'Pagar';
  @Input() isLoading: boolean = false;

  @Output() planSelected = new EventEmitter<any>();
  @Output() billingPeriodChanged = new EventEmitter<'monthly' | 'yearly'>();
  @Output() continue = new EventEmitter<void>();
  @Output() pay = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  setBillingPeriod(period: 'monthly' | 'yearly') {
    this.billingPeriod = period;
    this.billingPeriodChanged.emit(period);
  }

  selectPlan(plan: any) {
    this.selectedPlanId = plan.id;
    this.planSelected.emit(plan);
  }

  onContinue() {
    this.continue.emit();
  }

  onPay() {
    this.pay.emit();
  }

  onBack() {
    this.back.emit();
  }

}
